import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Typography, FormControlLabel, Checkbox, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Button } from '@mui/material';



// Ordem dos processos (igual ao ANP)
const processosOrdem = [
  'Guilhotina',
  'Pré-Impressão',
  'Impressão',
  'Laminadora',
  'Serigrafia',
  'Empastadeira',
  'Acopladeira',
  'Onduladeira',
  'Corte e Vinco',
  'Hotstamping',
  'Destaques',
  'Fechadora',
  'Fresa',
  'Caixa Rígida',
  'Bancada Caixa Rígida',
  'Bancada Clientes Diversos',
];

function PreOrcamentoProcessos({ itensProduto = [], materiasPrimas = [], componentes = [], onChangeComponentes }) {
 
  console.log('📦 Dados recebidos do GPD (componentes):', componentes);




   const [processos, setProcessos] = useState([]);
  const [impressoesSelecionadas, setImpressoesSelecionadas] = useState(
    componentes.map(c => c.impressao || '')
  );

  useEffect(() => {
    const novasImpressoes = componentes.map(c => c.impressao || '');
    setImpressoesSelecionadas(novasImpressoes);

    const deveIncluir = novasImpressoes.some(
      imp => imp === 'SÓ FRENTE' || imp === 'FRENTE E VERSO' || imp === 'REVERSÃO'
    );
    const todosSemImpressao = novasImpressoes.every(
      imp => imp === 'SEM IMPRESSÃO' || !imp
    );

    setProcessos(prev => {
      const jaTem = prev.includes('Impressão');
      if (deveIncluir && !jaTem) {
        return [...prev, 'Impressão'];
      } else if (todosSemImpressao && jaTem) {
        return prev.filter(p => p !== 'Impressão');
      }
      return prev;
    });
  }, [componentes]);





  const handleAddProcesso = (processo) => {
    if (!processos.includes(processo)) {
      setProcessos((prev) => [...prev, processo]);
    }
  };

  const handleRemoverProcesso = (processo) => {
    setProcessos((prev) => prev.filter(p => p !== processo));
  };

  const processosDisponiveis = processosOrdem.filter(p => !processos.includes(p));

  return (
    <div>
      {/* Título */}
      <h2 style={{ textAlign: 'center', marginTop: 20 }}>Selecione os Processos</h2>

      {/* Botões de processos */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, justifyContent: 'center', margin: '20px 0' }}>
        <AnimatePresence>
          {processosDisponiveis.map((p) => (
            <motion.button
              key={p}
              type="button"
              onClick={() => handleAddProcesso(p)}
              whileTap={{ scale: 0.95 }}
              whileHover={{ backgroundColor: '#298cfd', color: '#fff' }}
              initial={{ scale: 0.7, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.7, opacity: 0 }}
              style={{
                background: '#e4f0fd',
                border: 'none',
                borderRadius: 16,
                padding: '10px 16px',
                fontSize: 15,
                fontWeight: 'bold',
                color: '#126cc5',
                cursor: 'pointer',
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.1)',
                transition: 'background .2s, color .2s',
              }}
            >
              {p}
            </motion.button>
          ))}
        </AnimatePresence>
      </div>

      {/* Processos já adicionados */}
      <div style={{ marginTop: 20 }}>
        {processos.map((processo) => (

          <motion.div
            key={processo}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 30 }}
            transition={{ duration: 0.2 }}
            style={{
              marginBottom: 12,
              padding: 12,
              border: '1px solid #ccc',
              borderRadius: 8,
              backgroundColor: '#f9f9f9',
              position: 'relative',
              maxWidth: 1100,
              marginLeft: 'auto',
              marginRight: 'auto',
            }}
          >
            <strong>{processo}</strong>
            <button
              type="button"
              onClick={() => handleRemoverProcesso(processo)}
              style={{
                position: 'absolute',
                top: 8,
                right: 8,
                border: 'none',
                background: '#f7bfc4',
                borderRadius: '50%',
                width: 24,
                height: 24,
                cursor: 'pointer',
                color: '#b21a1a',
                fontWeight: 'bold',
                fontSize: 16,
                textAlign: 'center',
                boxShadow: '0 1px 2px #eab',
              }}
            >
              ×
            </button>






{/* FORMULÁRIO DE PROCESSOS COMEÇA AQUI */}

{/* IMPRESSÃO */}
{processo === 'Impressão' && (() => {
  const index = 0;
  const tipoImpressao = componentes[index]?.impressao || '';
  if (!tipoImpressao || tipoImpressao === 'SEM IMPRESSÃO') return null;

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
      <h4 style={{ marginBottom: 16, fontWeight: 600, color: '#333' }}>Item {index + 1}</h4>

      {/* Impressão + Especificação */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Impressão</InputLabel>
          <Select
            value={componentes[index]?.impressao || ''}
            onChange={(e) => {
              const valorSelecionado = e.target.value;
              const novas = [...impressoesSelecionadas];
              novas[index] = valorSelecionado;
              setImpressoesSelecionadas(novas);
              const novaLista = [...componentes];
              novaLista[index].impressao = valorSelecionado;
              onChangeComponentes(novaLista);
            }}
            label="Impressão"
            style={{ backgroundColor: '#fff', height: 40 }}
          >
            <MenuItem value="SÓ FRENTE">SÓ FRENTE</MenuItem>
            <MenuItem value="FRENTE E VERSO">FRENTE E VERSO</MenuItem>
            <MenuItem value="REVERSÃO">REVERSÃO</MenuItem>
            <MenuItem value="SEM IMPRESSÃO">SEM IMPRESSÃO</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Especificação de Cores</InputLabel>
          <Select
            value={componentes[index]?.quantidadeImpressao || ''}
            label="Especificação de Cores"
            style={{ backgroundColor: '#fff', height: 40 }}
          >
            {[
              '1x0', '1x1', '1x2', '1x3', '1x4', '1x5', '1x6',
              '2x0', '2x1', '2x2', '2x3', '2x4', '2x5', '2x6',
              '3x0', '3x1', '3x2', '3x3', '3x4', '3x5', '3x6',
              '4x0', '4x1', '4x2', '4x3', '4x4', '4x5', '4x6',
              '5x0', '5x1', '5x2', '5x3', '5x4', '5x5', '5x6',
              '6x0', '6x1', '6x2', '6x3', '6x4', '6x5', '6x6'
            ].map(opcao => (
              <MenuItem key={opcao} value={opcao}>{opcao}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>

      {/* Cores Frente */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 8, marginBottom: 12 }}>
        {[...Array(6)].map((_, i) => (
          <TextField
            key={`frente-${index}-${i}`}
            label={`Cor Frente ${i + 1}`}
            size="small"
            fullWidth
            variant="outlined"
            value={componentes[index]?.coresFrente?.[i] || ''}
            onChange={(e) => {
              const novaLista = [...componentes];
              const cores = [...(novaLista[index].coresFrente || [])];
              cores[i] = e.target.value;
              novaLista[index].coresFrente = cores;
              onChangeComponentes(novaLista);
            }}
            InputProps={{ style: { backgroundColor: '#fff' } }}
          />
        ))}
      </div>

      {/* Cores Verso */}
      {(impressoesSelecionadas[index] === 'FRENTE E VERSO' || impressoesSelecionadas[index] === 'REVERSÃO') && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: 8, marginBottom: 12 }}>
          {[...Array(6)].map((_, i) => (
            <TextField
              key={`verso-${index}-${i}`}
              label={`Cor Verso ${i + 1}`}
              size="small"
              fullWidth
              variant="outlined"
              value={componentes[index]?.coresVerso?.[i] || ''}
              onChange={(e) => {
                const novaLista = [...componentes];
                const cores = [...(novaLista[index].coresVerso || [])];
                cores[i] = e.target.value;
                novaLista[index].coresVerso = cores;
                onChangeComponentes(novaLista);
              }}
              InputProps={{ style: { backgroundColor: '#fff' } }}
            />
          ))}
        </div>
      )}



<TextField
  label="Marca da Tinta"
  variant="outlined"
  fullWidth
  size="small"
  value={componentes[index]?.marcaTinta || ''}
  onChange={(e) => {
    const novaLista = [...componentes];
    novaLista[index].marcaTinta = e.target.value;
    onChangeComponentes(novaLista);
  }}
  InputProps={{ style: { backgroundColor: '#fff' } }}
  InputLabelProps={{ style: { color: '#000' } }}
  style={{ marginBottom: 12 }}
/>





      {/* Matéria Prima */}
      <TextField
        label="Matéria Prima"
        variant="outlined"
        fullWidth
        size="small"
        value={materiasPrimas[index] || ''}
        InputProps={{
          readOnly: true,
          style: {
            backgroundColor: '#fff',
            color: '#000'
          }
        }}
        InputLabelProps={{ style: { color: '#000' } }}
        style={{ marginBottom: 12 }}
      />

      {/* Entradas, Máquina, Velocidade */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Quantas Entradas</InputLabel>
          <Select
            value={componentes[index]?.quantasEntradas || '1 ENTRADA'}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].quantasEntradas = e.target.value;
              onChangeComponentes(novaLista);
            }}
            label="Quantas Entradas"
            style={{ backgroundColor: '#fff', height: 40 }}
          >
            <MenuItem value="1 ENTRADA">1 ENTRADA</MenuItem>
            <MenuItem value="2 ENTRADAS">2 ENTRADAS</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Máquina</InputLabel>
          <Select
            value={componentes[index]?.maquina || 'KOMORI 1'}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].maquina = e.target.value;
              onChangeComponentes(novaLista);
            }}
            label="Máquina"
            style={{ backgroundColor: '#fff', height: 40 }}
          >
            <MenuItem value="KOMORI 1">KOMORI 1</MenuItem>
            <MenuItem value="KOMORI 2">KOMORI 2</MenuItem>
            <MenuItem value="KOMORI 3">KOMORI 3</MenuItem>
          </Select>
        </FormControl>

        <TextField
          label="Velocidade"
          variant="outlined"
          fullWidth
          size="small"
          value={componentes[index]?.velocidade || '6K P/H'}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].velocidade = e.target.value;
            onChangeComponentes(novaLista);
          }}
          InputProps={{ style: { backgroundColor: '#fff', height: 40 } }}
        />
      </div>

      {/* Acabamentos */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '5px', marginBottom: 16 }}>
        {[
          'VERNIZ BRILHO', 'VERNIZ FOSCO', 'VERNIZ BLISTER', 'VERNIZ PRIME',
          'VERNIZ SOFT', 'RESERVA DE COLA', 'DESMOLDANTE', 'PASTA FOSCO'
        ].map((acabamento, idxAcab) => (
          <div
            key={`acabamento-${idxAcab}`}
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 0
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
              {acabamento}
            </Typography>
            <div style={{ display: 'flex', marginRight: 60 }}>
              {['F', 'V'].map((lado) => {
                const valor = `${acabamento} (${lado})`;
                const estaMarcado = componentes[index]?.acabamentos?.includes(valor);
                return (
                  <FormControlLabel
                    key={lado}
                    control={
                      <Checkbox
                        size="small"
                        checked={estaMarcado}
                        onChange={() => {
                          const nova = [...componentes];
                          const listaAtual = nova[index].acabamentos || [];
                          if (estaMarcado) {
                            nova[index].acabamentos = listaAtual.filter(a => a !== valor);
                          } else {
                            nova[index].acabamentos = [...listaAtual, valor];
                          }
                          onChangeComponentes(nova);
                        }}
                      />
                    }
                    label={lado}
                    sx={{
                      m: 0,
                      pl: 0,
                      pr: 0,
                      '.MuiTypography-root': { fontSize: '0.7rem' }
                    }}
                  />
                );
              })}
            </div>
          </div>
        ))}
      </div>

      {/* Observações */}
      <TextField
        label="Observações"
        variant="outlined"
        multiline
        minRows={3}
        fullWidth
        value={componentes[index]?.observacoes || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].observacoes = e.target.value;
          onChangeComponentes(novaLista);
        }}
        InputProps={{
          style: {
            backgroundColor: '#fff',
            resize: 'vertical'
          }
        }}
      />
    </div>
  );
})()}


{/* SERIGRAFIA */}
{processo === 'Serigrafia' && (() => {
  const index = 0;
  return (
    <div style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
     
    {/* Frente / Verso */}
    <div style={{ display: 'flex', gap: 24, marginBottom: 16 }}>
      <FormControlLabel
        control={
          <Checkbox
            checked={componentes[index]?.serigrafiaFrente || false}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].serigrafiaFrente = e.target.checked;
              onChangeComponentes(novaLista);
            }}
          />
        }
        label="Frente"
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={componentes[index]?.serigrafiaVerso || false}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].serigrafiaVerso = e.target.checked;
              onChangeComponentes(novaLista);
            }}
          />
        }
        label="Verso"
      />
    </div>

    {/* Entradas e Velocidade */}
    <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
      <FormControl fullWidth variant="outlined" size="small">
        <InputLabel>Quantas Entradas de Máquina</InputLabel>
        <Select
          value={componentes[index]?.quantasEntradas || '1 ENTRADA'}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].quantasEntradas = e.target.value;
            onChangeComponentes(novaLista);
          }}
          label="Quantas Entradas de Máquina"
          style={{ backgroundColor: '#fff', height: 40 }}
        >
          <MenuItem value="1 ENTRADA">1 ENTRADA</MenuItem>
          <MenuItem value="2 ENTRADAS">2 ENTRADAS</MenuItem>
        </Select>
      </FormControl>

      <TextField
        label="Velocidade"
        variant="outlined"
        fullWidth
        size="small"
        value={componentes[index]?.velocidade || '1.500 FLS P/H'}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].velocidade = e.target.value;
          onChangeComponentes(novaLista);
        }}
        InputProps={{ style: { backgroundColor: '#fff', height: 40 } }}
      />
    </div>

    {/* Acabamentos Serigráficos */}
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 16 }}>
      {[
        'Brilho',
        'Textura',
        'Fosco',
        'Tinta Serigráfica',
        'Gliter',
        'Relevo'
      ].map((acabamento, idx) => (
        <FormControlLabel
          key={idx}
          control={
            <Checkbox
              checked={componentes[index]?.acabamentosSerigrafia?.includes(acabamento) || false}
              onChange={() => {
                const novaLista = [...componentes];
                const listaAtual = novaLista[index].acabamentosSerigrafia || [];
                if (listaAtual.includes(acabamento)) {
                  novaLista[index].acabamentosSerigrafia = listaAtual.filter(a => a !== acabamento);
                } else {
                  novaLista[index].acabamentosSerigrafia = [...listaAtual, acabamento];
                }
                onChangeComponentes(novaLista);
              }}
            />
          }
          label={acabamento}
        />
      ))}
    </div>

    {/* Fotolito Custo */}
    <TextField
      label="Fotolito Custo"
      variant="outlined"
      fullWidth
      size="small"
      value={componentes[index]?.fotolitoCusto || 'R$ 256,00'}
      onChange={(e) => {
        const novaLista = [...componentes];
        novaLista[index].fotolitoCusto = e.target.value;
        onChangeComponentes(novaLista);
      }}
      InputProps={{ style: { backgroundColor: '#fff' } }}
      style={{ marginBottom: 16 }}
    />

    {/* Observações */}
    <TextField
      label="Observações"
      variant="outlined"
      multiline
      minRows={3}
      fullWidth
      value={componentes[index]?.observacoesSerigrafia || ''}
      onChange={(e) => {
        const novaLista = [...componentes];
        novaLista[index].observacoesSerigrafia = e.target.value;
        onChangeComponentes(novaLista);
      }}
      InputProps={{ style: { backgroundColor: '#fff', resize: 'vertical' } }}
    />
    </div>
  );
})()}


{/* FECHADORA */}
{processo === 'Fechadora' && (() => {
  const index = 0;
  const grupo = componentes[index]?.fechadora || {};
  const entradas = Array.isArray(grupo.entradas) ? grupo.entradas : [];

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
      <h4 style={{ marginBottom: 16, fontWeight: 600, color: '#333' }}>Item {index + 1}</h4>

      {/* Máquina */}
      <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 12 }}>
        <InputLabel>Máquina</InputLabel>
        <Select
          value={grupo.maquina || ''}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].fechadora = { ...grupo, maquina: e.target.value };
            onChangeComponentes(novaLista);
          }}
          label="Máquina"
          style={{ backgroundColor: '#fff', height: 40 }}
        >
          <MenuItem value="ZH1000">ZH1000</MenuItem>
          <MenuItem value="SBL I">SBL I</MenuItem>
          <MenuItem value="SBL II">SBL II</MenuItem>
          <MenuItem value="SBL I E II">SBL I E II</MenuItem>
          <MenuItem value="STS">STS</MenuItem>
        </Select>
      </FormControl>

      {/* Fundo Automático e Lateral */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.fundoAutomatico || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].fechadora = { ...grupo, fundoAutomatico: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="Fundo Automático"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.lateral || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].fechadora = { ...grupo, lateral: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="Lateral"
        />
      </div>

      {/* ITEM FIXO: Item/Entrada 1 */}
      <div style={{ border: '1px dashed #999', padding: 10, marginBottom: 12, borderRadius: 6 }}>
        <div style={{ display: 'flex', gap: 12, marginBottom: 8 }}>
          <TextField
            label="Item/Entrada 1"
            fullWidth
            size="small"
            variant="outlined"
            value={grupo.itemEntrada || ''}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].fechadora = { ...grupo, itemEntrada: e.target.value };
              onChangeComponentes(novaLista);
            }}
          />

          <TextField
            label="Velocidade de Fechamento"
            fullWidth
            size="small"
            variant="outlined"
            value={grupo.velocidade || ''}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].fechadora = { ...grupo, velocidade: e.target.value };
              onChangeComponentes(novaLista);
            }}
          />
        </div>

        <div style={{ display: 'flex', gap: 12, marginBottom: 8 }}>
          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Pontos de Cola</InputLabel>
            <Select
              value={['1', '2', '3'].includes(String(grupo.pontosCola || '')) ? String(grupo.pontosCola) : ''}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].fechadora = {
                  ...grupo,
                  pontosCola: e.target.value.toString()
                };
                onChangeComponentes(novaLista);
              }}
              label="Pontos de Cola"
              style={{ backgroundColor: '#fff', height: 40 }}
            >
              <MenuItem value="1">1</MenuItem>
              <MenuItem value="2">2</MenuItem>
              <MenuItem value="3">3</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth variant="outlined" size="small">
            <InputLabel>Tipo de Cola</InputLabel>
            <Select
              value={grupo.tipoCola || ''}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].fechadora = { ...grupo, tipoCola: e.target.value };
                onChangeComponentes(novaLista);
              }}
              label="Tipo de Cola"
              style={{ backgroundColor: '#fff', height: 40 }}
            >
              <MenuItem value="C362">C362</MenuItem>
              <MenuItem value="C363">C363</MenuItem>
              <MenuItem value="HOTMELT">HOTMELT</MenuItem>
              <MenuItem value="HHS">HHS</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>

      {/* PONTOS DE COLA ADICIONAIS */}
      {entradas.map((entrada, entradaIndex) => (
        <div key={entradaIndex} style={{ border: '1px dashed #999', padding: 10, marginBottom: 12, borderRadius: 6 }}>
          <div style={{ display: 'flex', gap: 12, marginBottom: 8 }}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Pontos de Cola</InputLabel>
              <Select
                value={['1', '2', '3'].includes(String(entrada?.pontosCola || '')) ? String(entrada.pontosCola) : ''}
                onChange={(e) => {
                  const nova = [...entradas];
                  nova[entradaIndex] = {
                    ...nova[entradaIndex],
                    pontosCola: e.target.value.toString()
                  };
                  const novaLista = [...componentes];
                  novaLista[index].fechadora = { ...grupo, entradas: nova };
                  onChangeComponentes(novaLista);
                }}
                label="Pontos de Cola"
                style={{ backgroundColor: '#fff', height: 40 }}
              >
                <MenuItem value="1">1</MenuItem>
                <MenuItem value="2">2</MenuItem>
                <MenuItem value="3">3</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel>Tipo de Cola</InputLabel>
              <Select
                value={entrada.tipoCola || ''}
                onChange={(e) => {
                  const nova = [...entradas];
                  nova[entradaIndex] = { ...nova[entradaIndex], tipoCola: e.target.value };
                  const novaLista = [...componentes];
                  novaLista[index].fechadora = { ...grupo, entradas: nova };
                  onChangeComponentes(novaLista);
                }}
                label="Tipo de Cola"
                style={{ backgroundColor: '#fff', height: 40 }}
              >
                <MenuItem value="C362">C362</MenuItem>
                <MenuItem value="C363">C363</MenuItem>
                <MenuItem value="HOTMELT">HOTMELT</MenuItem>
                <MenuItem value="HHS">HHS</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
      ))}

      {/* Botões de ação */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            const entradasAtuais = grupo.entradas || [];
            const nova = [...entradasAtuais, {}];
            const novaLista = [...componentes];
            novaLista[index].fechadora = { ...grupo, entradas: nova };
            onChangeComponentes(novaLista);
          }}
        >
          + Adicionar PONTO DE COLA
        </Button>

        {entradas.length > 0 && (
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={() => {
              const nova = entradas.slice(0, -1);
              const novaLista = [...componentes];
              novaLista[index].fechadora = { ...grupo, entradas: nova };
              onChangeComponentes(novaLista);
            }}
          >
            - Remover PONTO DE COLA
          </Button>
        )}
      </div>

      {/* Quant. de Entrada em Máquina */}
      <FormControl fullWidth variant="outlined" size="small" style={{ marginBottom: 12 }}>
        <InputLabel>Quant. de Entrada em Máquina</InputLabel>
        <Select
          value={grupo.qtdEntradaMaquina || ''}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].fechadora = { ...grupo, qtdEntradaMaquina: e.target.value };
            onChangeComponentes(novaLista);
          }}
          label="Quant. de Entrada em Máquina"
          style={{ backgroundColor: '#fff', height: 40 }}
        >
          <MenuItem value="1">1</MenuItem>
          <MenuItem value="2">2</MenuItem>
          <MenuItem value="3">3</MenuItem>
        </Select>
      </FormControl>

      {/* Destaque */}
      <TextField
        label="Destaque"
        fullWidth
        size="small"
        variant="outlined"
        value={grupo.destaque || '40K P/H COM 1 PESSOA'}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].fechadora = { ...grupo, destaque: e.target.value };
          onChangeComponentes(novaLista);
        }}
        style={{ marginBottom: 12 }}
      />

      {/* Observações */}
      <TextField
        label="Observações"
        variant="outlined"
        multiline
        minRows={3}
        fullWidth
        value={grupo.observacoes || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].fechadora = { ...grupo, observacoes: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{
          style: {
            backgroundColor: '#fff',
            resize: 'vertical',
          },
        }}
      />
    </div>
  );
})()}


{/* LAMINADORA */}
{processo === 'Laminadora' && (() => {
  const index = 0;
  const grupo = componentes[index]?.laminadora || {};

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
      
      {/* Frente e Verso (Checkboxes) */}
      <div style={{ display: 'flex', gap: 24, marginBottom: 16 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.frente || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].laminadora = { ...grupo, frente: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="FRENTE"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.verso || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].laminadora = { ...grupo, verso: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="VERSO"
        />
      </div>

      {/* Velocidade da Máquina */}
      <TextField
        label="Velocidade da Máquina"
        fullWidth
        size="small"
        variant="outlined"
        value={grupo.velocidade || '1.500 FLS P/H'}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].laminadora = { ...grupo, velocidade: e.target.value };
          onChangeComponentes(novaLista);
        }}
        style={{ marginBottom: 16 }}
      />

      {/* Linha de tipos de laminação */}
      <div style={{ display: 'flex', gap: 24, marginBottom: 16 }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.brilho || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].laminadora = { ...grupo, brilho: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="Brilho"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.fosco || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].laminadora = { ...grupo, fosco: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="Fosco"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.softTouch || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].laminadora = { ...grupo, softTouch: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="Soft Touch"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.scuffFree || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].laminadora = { ...grupo, scuffFree: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="Scuff Free"
        />
      </div>

      {/* Outro */}
      <TextField
        label="Outro"
        fullWidth
        size="small"
        variant="outlined"
        value={grupo.outro || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].laminadora = { ...grupo, outro: e.target.value };
          onChangeComponentes(novaLista);
        }}
        style={{ marginBottom: 16 }}
      />

      {/* Fornecedor */}
      <TextField
        label="Fornecedor"
        fullWidth
        size="small"
        variant="outlined"
        value={grupo.fornecedor || 'BIG AMERICAN'}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].laminadora = { ...grupo, fornecedor: e.target.value };
          onChangeComponentes(novaLista);
        }}
        style={{ marginBottom: 16 }}
      />

      {/* Observações */}
      <TextField
        label="Observações"
        variant="outlined"
        multiline
        minRows={3}
        fullWidth
        value={grupo.observacoes || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].laminadora = { ...grupo, observacoes: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{
          style: {
            backgroundColor: '#fff',
            resize: 'vertical',
          },
        }}
      />
    </div>
  );
})()}


{/* ACOPLADEIRA */}
{processo === 'Acopladeira' && (() => {
  const index = 0;
  const grupo = componentes[index]?.acopladeira || {};

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
      {/* REMOVIDO Item 1 */}

      {/* Máquina - SBL e SPIRE (em uma linha) */}
      <div style={{ display: 'flex', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.sbl || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].acopladeira = { ...grupo, sbl: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="SBL"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={grupo.spire || false}
              onChange={(e) => {
                const novaLista = [...componentes];
                novaLista[index].acopladeira = { ...grupo, spire: e.target.checked };
                onChangeComponentes(novaLista);
              }}
            />
          }
          label="SPIRE"
        />
      </div>

      {/* Tipo de Acoplamento + Quantas Entradas (em uma linha) */}
      <div style={{ display: 'flex', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Tipo de Acoplamento</InputLabel>
          <Select
            value={grupo.tipoAcoplamento || ''}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].acopladeira = { ...grupo, tipoAcoplamento: e.target.value };
              onChangeComponentes(novaLista);
            }}
            label="Tipo de Acoplamento"
          >
            <MenuItem value="SIMPLES (3 CAMADAS)">SIMPLES (3 CAMADAS)</MenuItem>
            <MenuItem value="DUPLO (4 CAMADAS)">DUPLO (4 CAMADAS)</MenuItem>
            <MenuItem value="CARTÃO + CARTÃO (2 CAMADAS)">CARTÃO + CARTÃO (2 CAMADAS)</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth variant="outlined" size="small">
          <InputLabel>Quantas Entradas em Máquina</InputLabel>
          <Select
            value={grupo.quantasEntradas || ''}
            onChange={(e) => {
              const novaLista = [...componentes];
              novaLista[index].acopladeira = { ...grupo, quantasEntradas: e.target.value };
              onChangeComponentes(novaLista);
            }}
            label="Quantas Entradas em Máquina"
          >
            <MenuItem value="1">1</MenuItem>
            <MenuItem value="2">2</MenuItem>
          </Select>
        </FormControl>
      </div>

      {/* Velocidade de Produção */}
      <TextField
        label="Velocidade de Produção"
        variant="outlined"
        fullWidth
        size="small"
        value={grupo.velocidade || '2.000 FLS P/H'}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].acopladeira = { ...grupo, velocidade: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{ style: { backgroundColor: '#fff' } }}
        InputLabelProps={{ style: { color: '#000' } }}
        style={{ marginBottom: 16 }}
      />

      {/* Observações - campo adaptável */}
      <TextField
        label="Observações"
        variant="outlined"
        fullWidth
        multiline
        minRows={3}
        value={grupo.observacoes || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].acopladeira = { ...grupo, observacoes: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{ style: { backgroundColor: '#fff' } }}
      />
    </div>
  );
})()}


{/* CLICHÊ DE RELEVO */}
{processo === 'Clichê de Relevo' && (() => {
  const index = 0;
  const grupo = componentes[index]?.clicheRelevo || {};
  const cliches = Array.isArray(grupo.cliches) ? grupo.cliches : [{}];

  const atualizarGrupo = (novoGrupo) => {
    const novaLista = [...componentes];
    novaLista[index].clicheRelevo = novoGrupo;
    onChangeComponentes(novaLista);
  };

  const atualizarCliche = (clicheIndex, novosValores) => {
    const novos = [...cliches];
    novos[clicheIndex] = { ...novos[clicheIndex], ...novosValores };
    atualizarGrupo({ ...grupo, cliches: novos });
  };

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
      <h4 style={{ marginBottom: 16, fontWeight: 600, color: '#333' }}>Clichê de Relevo</h4>

      {cliches.map((cliche, i) => (
        <div key={i} style={{ border: '1px dashed #999', padding: 10, marginBottom: 16, borderRadius: 6 }}>
          {/* ALTO e BAIXO */}
          <div style={{ display: 'flex', gap: 24, marginBottom: 12 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={cliche.alto || false}
                  onChange={(e) => atualizarCliche(i, { alto: e.target.checked })}
                />
              }
              label="ALTO"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={cliche.baixo || false}
                  onChange={(e) => atualizarCliche(i, { baixo: e.target.checked })}
                />
              }
              label="BAIXO"
            />
          </div>

          {/* FORMATO, VALOR UNIT, N DE CLICHÊS, TOTAL */}
          <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
            <TextField
              label="Formato"
              fullWidth
              size="small"
              variant="outlined"
              value={cliche.formato || ''}
              onChange={(e) => atualizarCliche(i, { formato: e.target.value })}
            />
            <TextField
              label="Valor Unit. do Clichê"
              fullWidth
              size="small"
              variant="outlined"
              value={cliche.valorUnitario || ''}
              onChange={(e) => atualizarCliche(i, { valorUnitario: e.target.value })}
              InputProps={{ startAdornment: <span style={{ marginRight: 4 }}>R$</span> }}
            />
            <TextField
              label="Nº de Clichês"
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              value={cliche.quantidade || ''}
              onChange={(e) => atualizarCliche(i, { quantidade: e.target.value })}
            />
            <TextField
              label="Valor Total do Clichê"
              fullWidth
              size="small"
              variant="outlined"
              value={
                (parseFloat(cliche.valorUnitario) * parseFloat(cliche.quantidade) || 0).toFixed(2)
              }
              InputProps={{ startAdornment: <span style={{ marginRight: 4 }}>R$</span> }}
              disabled
            />
          </div>
        </div>
      ))}

      {/* Botões de Ação */}
      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={() => {
            const novo = [...cliches, {}];
            atualizarGrupo({ ...grupo, cliches: novo });
          }}
        >
          + Adicionar Clichê
        </Button>
        {cliches.length > 1 && (
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={() => {
              const novo = cliches.slice(0, -1);
              atualizarGrupo({ ...grupo, cliches: novo });
            }}
          >
            - Remover Clichê
          </Button>
        )}
      </div>

      {/* Observações */}
      <TextField
        label="Observações"
        variant="outlined"
        multiline
        minRows={3}
        fullWidth
        value={grupo.observacoes || ''}
        onChange={(e) => atualizarGrupo({ ...grupo, observacoes: e.target.value })}
        InputProps={{
          style: {
            backgroundColor: '#fff',
            resize: 'vertical',
          },
        }}
      />
    </div>
  );
})()}


{/* EMPASTADEIRA */}
{processo === 'Empastadeira' && (() => {
  const index = 0;
  const grupo = componentes[index]?.empastadeira || {};

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
      <h4 style={{ marginBottom: 16, fontWeight: 600, color: '#333' }}>Item {index + 1}</h4>

      {/* Velocidade de Produção + Tipo de Cola */}
      <div style={{ display: 'flex', gap: 24, marginBottom: 16 }}>
        <TextField
          label="Velocidade de Produção"
          variant="outlined"
          fullWidth
          size="small"
          value={grupo.velocidadeProducao || '1.000 FLS P/H (1H DE ACERTO)'}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].empastadeira = { ...grupo, velocidadeProducao: e.target.value };
            onChangeComponentes(novaLista);
          }}
          InputProps={{ style: { backgroundColor: '#fff' } }}
          InputLabelProps={{ style: { color: '#000' } }}
        />

        <TextField
          label="Tipo de Cola"
          variant="outlined"
          fullWidth
          size="small"
          value={grupo.tipoCola || 'C-502'}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].empastadeira = { ...grupo, tipoCola: e.target.value };
            onChangeComponentes(novaLista);
          }}
          InputProps={{ style: { backgroundColor: '#fff' } }}
          InputLabelProps={{ style: { color: '#000' } }}
        />
      </div>

      {/* Observações com altura dinâmica */}
      <TextField
        label="Observações"
        variant="outlined"
        fullWidth
        multiline
        minRows={3}
        value={grupo.observacoes || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].empastadeira = { ...grupo, observacoes: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{ style: { backgroundColor: '#fff' } }}
      />
    </div>
  );
})()}


{/* HOTSTAMPING */}
{processo === 'Hotstamping' && (() => {
  const index = 0;
  const grupo = componentes[index]?.hotstamping || {};

  const duplicatas = Array.isArray(grupo.duplicatas) && grupo.duplicatas.length > 0
    ? grupo.duplicatas
    : [{}]; // sempre inicia com uma linha

  const handleChangeDuplicata = (campo, valor, i) => {
    const novaLista = [...duplicatas];
    novaLista[i] = { ...novaLista[i], [campo]: valor };

    const novaComponentes = [...componentes];
    novaComponentes[index].hotstamping = { ...grupo, duplicatas: novaLista };
    onChangeComponentes(novaComponentes);
  };

  const adicionarDuplicata = () => {
    const novaLista = [...duplicatas, {}];
    const novaComponentes = [...componentes];
    novaComponentes[index].hotstamping = { ...grupo, duplicatas: novaLista };
    onChangeComponentes(novaComponentes);
  };

  const removerUltimaDuplicata = () => {
    const novaLista = duplicatas.slice(0, -1);
    const novaComponentes = [...componentes];
    novaComponentes[index].hotstamping = {
      ...grupo,
      duplicatas: novaLista.length > 0 ? novaLista : [{}] // garante que pelo menos 1 fique
    };
    onChangeComponentes(novaComponentes);
  };

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>
      {duplicatas.map((linha, i) => (
        <div key={i} style={{ marginBottom: 16, border: '1px dashed #aaa', padding: 12, borderRadius: 8 }}>
          <h5 style={{ marginBottom: 12, fontWeight: 500, color: '#444' }}>Clichê {i + 1}</h5>

          <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
            <TextField
              label="FORMATO"
              fullWidth
              size="small"
              variant="outlined"
              value={linha.formato || ''}
              onChange={(e) => handleChangeDuplicata('formato', e.target.value, i)}
            />
            <TextField
              label="VALOR UNIT. DO CLICHÊ"
              fullWidth
              size="small"
              variant="outlined"
              InputProps={{
                startAdornment: <span style={{ marginRight: 4 }}>R$</span>,
              }}
              value={linha.valorUnitario || ''}
              onChange={(e) => handleChangeDuplicata('valorUnitario', e.target.value, i)}
            />
          </div>

          <div style={{ display: 'flex', gap: 12 }}>
            <TextField
              label="N° DE CLICHÊS"
              fullWidth
              size="small"
              variant="outlined"
              type="number"
              value={linha.qtd || ''}
              onChange={(e) => handleChangeDuplicata('qtd', e.target.value, i)}
            />
            <TextField
              label="VALOR TOTAL DO CLICHÊ"
              fullWidth
              size="small"
              variant="outlined"
              value={
                linha.valorUnitario && linha.qtd
                  ? `R$ ${(parseFloat(linha.valorUnitario || 0) * parseInt(linha.qtd || 0)).toFixed(2)}`
                  : 'R$ 0,00'
              }
              InputProps={{
                readOnly: true,
                style: { backgroundColor: '#f5f5f5' },
              }}
            />
            <TextField
              label="TIPO/COR"
              fullWidth
              size="small"
              variant="outlined"
              value={linha.tipoCor || ''}
              onChange={(e) => handleChangeDuplicata('tipoCor', e.target.value, i)}
            />
          </div>
        </div>
      ))}

      <div style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
        <Button
          variant="outlined"
          size="small"
          onClick={adicionarDuplicata}
        >
          + Adicionar CLICHÊ
        </Button>

        {duplicatas.length > 1 && (
          <Button
            variant="outlined"
            size="small"
            color="error"
            onClick={removerUltimaDuplicata}
          >
            - Remover Último CLICHÊ
          </Button>
        )}
      </div>

      {/* Observações */}
      <TextField
        label="Observações"
        variant="outlined"
        multiline
        fullWidth
        minRows={3}
        value={grupo.observacoes || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].hotstamping = { ...grupo, observacoes: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{
          style: {
            backgroundColor: '#fff',
            resize: 'vertical',
          },
        }}
      />
    </div>
  );
})()}


{/* CORTE E VINCO */}
{processo === 'Corte e Vinco' && (() => {
  const index = 0;
  const grupo = componentes[index]?.corteVinco || {};

  // Campo FACA baseado em 80 * metrosLineares
  const metrosLineares = parseFloat(componentes[index]?.metrosLineares || 0);
  const facaCalculada = metrosLineares * 80;
  const pertinaxCalculado = facaCalculada / 2;
  const destacadorCalculado = facaCalculada / 2;

  return (
    <div key={index} style={{ marginTop: 24, padding: 12, border: '1px solid #ccc', borderRadius: 8 }}>

      {/* MÁQUINA: SBL, BOBST, HERC, MANUAL */}
      <div style={{ display: 'flex', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
        {['SBL', 'BOBST', 'HERC', 'MANUAL'].map((tipo) => (
          <FormControlLabel
            key={tipo}
            control={
              <Checkbox
                checked={grupo[tipo.toLowerCase()] || false}
                onChange={(e) => {
                  const novaLista = [...componentes];
                  novaLista[index].corteVinco = { ...grupo, [tipo.toLowerCase()]: e.target.checked };
                  onChangeComponentes(novaLista);
                }}
              />
            }
            label={tipo}
          />
        ))}
      </div>

      {/* Velocidade de Produção */}
      <TextField
        label="Velocidade de Produção"
        variant="outlined"
        fullWidth
        size="small"
        value={grupo.velocidade || '4.000 FLS P/H (4H DE ACERTO)'}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].corteVinco = { ...grupo, velocidade: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{ style: { backgroundColor: '#fff' } }}
        InputLabelProps={{ style: { color: '#000' } }}
        style={{ marginBottom: 16 }}
      />

      {/* FACA, PERTINAX, DESTACADOR */}
      <div style={{ display: 'flex', gap: 24, marginBottom: 16, flexWrap: 'wrap' }}>
        <TextField
          label="Faca"
          variant="outlined"
          size="small"
          value={grupo.faca || `R$ ${facaCalculada.toFixed(2)}`}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].corteVinco = { ...grupo, faca: e.target.value };
            onChangeComponentes(novaLista);
          }}
          InputProps={{ style: { backgroundColor: '#fff' } }}
          InputLabelProps={{ style: { color: '#000' } }}
          style={{ flex: 1 }}
        />

        <TextField
          label="Pertinax"
          variant="outlined"
          size="small"
          value={grupo.pertinax || `R$ ${(pertinaxCalculado).toFixed(2)}`}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].corteVinco = { ...grupo, pertinax: e.target.value };
            onChangeComponentes(novaLista);
          }}
          InputProps={{ style: { backgroundColor: '#fff' } }}
          InputLabelProps={{ style: { color: '#000' } }}
          style={{ flex: 1 }}
        />

        <TextField
          label="Destacador"
          variant="outlined"
          size="small"
          value={grupo.destacador || `R$ ${(destacadorCalculado).toFixed(2)}`}
          onChange={(e) => {
            const novaLista = [...componentes];
            novaLista[index].corteVinco = { ...grupo, destacador: e.target.value };
            onChangeComponentes(novaLista);
          }}
          InputProps={{ style: { backgroundColor: '#fff' } }}
          InputLabelProps={{ style: { color: '#000' } }}
          style={{ flex: 1 }}
        />
      </div>

      {/* Observações */}
      <TextField
        label="Observações"
        variant="outlined"
        fullWidth
        multiline
        minRows={3}
        value={grupo.observacoes || ''}
        onChange={(e) => {
          const novaLista = [...componentes];
          novaLista[index].corteVinco = { ...grupo, observacoes: e.target.value };
          onChangeComponentes(novaLista);
        }}
        InputProps={{ style: { backgroundColor: '#fff' } }}
      />
    </div>
  );
})()}






 
          </motion.div>
        ))}
      </div>
    </div>
  );
}

export default PreOrcamentoProcessos;
